import { render, staticRenderFns } from "./QuestionBankManage.vue?vue&type=template&id=6c2f5874&scoped=true"
import script from "./QuestionBankManage.vue?vue&type=script&lang=js"
export * from "./QuestionBankManage.vue?vue&type=script&lang=js"
import style0 from "./QuestionBankManage.vue?vue&type=style&index=0&id=6c2f5874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f5874",
  null
  
)

export default component.exports